import type { FC } from 'react';
import React from 'react';
import {
  Typography, ListItem, Box,
} from '@material-ui/core';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import type { SWRResponse } from 'swr/dist/types';
import MessageItem from './MessageItem';
import MessageModal from './MessageModal';
import type { Message } from './NotificationTypes';

const useStyles = makeStyles(() => createStyles({
  listHeader: {
    padding: 0,
    backgroundColor: '#efefef',
    '& .MuiTypography-body1': {
      margin: 0,
    },
  },
}));

interface MessageSectionProps {
  messages: Message[],
  header: string,
  hideHeader?: boolean,
  notificationMutate: SWRResponse<{ notifications:Message[] }, unknown>['mutate']
}

const MessageSection: FC<MessageSectionProps> = ({
  messages, header, hideHeader = false, notificationMutate,
}): JSX.Element => {
  const classes = useStyles();
  const untouchedCount = messages.filter((message) => !message.acknowledged).length;
  const [selectedNotification, setSelectedNotification] = React.useState<Message>();

  return (
    <>
      { selectedNotification
      && (
      <MessageModal
        open={Boolean(selectedNotification)}
        onClose={() => setSelectedNotification(undefined)}
        notification={selectedNotification}
        notificationMutate={notificationMutate}
      />
      )}
      {!hideHeader && (
        <ListItem className={classes.listHeader} divider autoFocus>
          <Box px={3} py={1.5}>
            <Typography variant="body1">
              {header}
              {untouchedCount > 0 && (
                <span>{` (${untouchedCount})`}</span>
              )}
            </Typography>
          </Box>
        </ListItem>
      )}
      {messages.map((message) => (
        <MessageItem
          onClickFunction={() => setSelectedNotification(message)}
          message={message}
          key={message.id}
        />
      ))}
    </>
  );
};

export default MessageSection;
